export const isValidHexColor = (color: string): boolean => {
    return /^#?[0-9a-fA-F]*$/.test(color);
};
